import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {
    CadastrarClienteController,
    ListarCidadesController,
    ListarEstadosController,
    ListarProfissoesController,
    ListarSetorController,
    ListarTipoContasController,
} from "../../../../Controllers/Geral/CadastrarCliente/CadastrarClienteController";
import { ListarTipoRelacaoClienteController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import {
    ICadastrarCliente,
    IConta,
    IContato,
    IPerfilFinanceiro,
} from "../../../../Interfaces/Geral/CadastrarCliente/CadastrarClienteInterfaces";
import { useHistory } from "react-router-dom";
import { ACESSOS } from "../../../../Routes/Acessos";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { ListarCanalAtendimentoContoller } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoController";
import { ListarBancosController } from "../../../../Controllers/Geral/ListarBancosController/ListarBancosController";
import { GetOrigemLeadController } from "../../../../Controllers/Repasse/OrigemLeadRepasse/OrigemLeadRepasseControllers";
import { ListarPerfilFinanceiroController } from "../../../../Controllers/Geral/GestaoDeCadastros/PerfilFinanceiro/PerfilFinanceiroController";
import { useUserInfor } from "../../../../Context/User";
import moment from "moment";
import { ListarPerfilTipoContaController } from "../../../../Controllers/Geral/CadastroEEditaTipoConta/CadastroEEditaTipoContaController";
import { ListarCategoriasAtendimentosPaiController } from "../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import { ListarMotivoCompraController } from "../../../../Controllers/Geral/GestaoDeCadastros/MotivoCompra/MotivoCompraControllers";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import Select from "react-select";
import { ChangeEvent, useEffect, useState } from "react";
import {
    FormatadorParaCEP,
    FormatadorParaRG,
    MoneyReaisFieldMask,
    formatterCPF_CNPJ,
} from "../../../../Validations/InputMasks";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { GetCidadeController } from "../../../../Controllers/Geral/Endereco/Cidade/CidadeControllers";
import { BuscaCEP } from "../../../../Services/Tools/ViaCep";
import { ValidationErr } from "../../../../Validations/ValidationError";
import { ICidade } from "../../../../Interfaces/Geral/Endereco/Cidade/CidadeInterfaces";
import { createWizard } from "../../../../Components/Utils/Wizard";
import LazySelect from "../../../../Components/CardsPages/Forms/LazySelect";
import { Switch } from "../../../../Components/CardsPages/Forms/Switch";

const objContaStepInputs = ["DS_NOME", "ID_TIPO_CONTA"] as Array<
    keyof ICadastrarCliente["CONTA"]
>;

const objContaDocsCadastroContaStepInputs = ["NR_CPF"] as Array<
    keyof IConta["DOCS_CADASTRO_CONTA"]
>;

const objContaPerfilClienteStepInputs = ["DS_EMAIL"] as Array<
    keyof IConta["PERFIL_CLIENTE"]
>;

const objContatoStepInputs = ["DS_EMAIL", "DS_NOME"] as Array<keyof IContato>;

const {
    useWizard,
    Wizard,
    WizardStep,
    WizardControl,
    WizardControlStep,
    WizardControlStepButton,
} = createWizard([
    "Conta",
    "Endereco",
    "PerfilCliente",
    "PerfilFinanceiro",
    "InformacaoCadastroConta",
    "DocumentosCadastroConta",
    "DadosBancariosCobranca",
    "OcupacaoConta",
    "LeadConta",
    "Contato",
    "CadastrarCliente",
]);

export default function CadastrarCliente() {
    const formCadastrarCliente = useForm<ICadastrarCliente>();
    const { register, formState, getValues, setValue, trigger, handleSubmit } =
        formCadastrarCliente;
    const formMethods = useFormContext<ICadastrarCliente>();
    const { UserInfor } = useUserInfor();

    const objContaIsValid = objContaStepInputs.every(
        (input) => !formState.errors.CONTA?.[input]
    );

    const objContaDocsCadastroContaIsValid =
        objContaDocsCadastroContaStepInputs.every(
            (input) => !formState.errors.CONTA?.DOCS_CADASTRO_CONTA?.[input]
        );

    const objContaPerfilClienteIsValid = objContaPerfilClienteStepInputs.every(
        (input) => !formState.errors.CONTA?.PERFIL_CLIENTE?.[input]
    );

    const objContatoIsValid = objContatoStepInputs.every(
        (input) => !formState.errors.CONTATO?.[input]
    );

    const wizard = useWizard();

    const [cidade, setCidade] = useState<ICidade>();
    const [estadoID, setEstadoID] = useState<number>();

    const [idNrCPF, setIdNrCPF] = useState<string>("");
    const [idEstado, setIdEstado] = useState<string | number>();
    const [optionsEstado, setOptionsEstado] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const { value: lstEstados } = useAsyncEffect(
        () => ListarEstadosController(),
        []
    );
    function geradorMascaraFinanceiraPerfiLFinanceiro(
        inputName: keyof IPerfilFinanceiro
    ) {
        return (e: ChangeEvent<HTMLInputElement>) => {
            const mask = MoneyReaisFieldMask(e);
            formMethods?.setValue(inputName, mask);
        };
    }
    const [idProfissao, setIdProfissao] = useState<string | number[]>([]);
    const [optionsProfissoes, setOptionsProfissoes] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const [idCidade, setIdCidade] = useState<string | number>();
    const [optionsCidade, setOptionsCidade] = useState<
        Array<{ value: number; label: string }> | undefined
    >();
    const { value: lstCidades } = useAsyncEffect(
        () => ListarCidadesController(Number(idEstado ?? 0) ?? 0),
        [idEstado]
    );
    const { value: lstProfissoes } = useAsyncEffect(
        () => ListarProfissoesController(),
        []
    );
    const { execute: listarCanalAtendimento } = useAsyncCallback(
        () => ListarCanalAtendimentoContoller(),
        []
    );
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };
    useEffect(() => {
        setOptionsProfissoes(() =>
            lstProfissoes?.map((empreendimento) => ({
                label: empreendimento.DS_PROFISSAO,
                value: empreendimento.ID_PROFISSAO,
            }))
        );
        setOptionsEstado(() =>
            lstEstados?.map((empreendimento) => ({
                label: empreendimento.DS_ESTADO,
                value: empreendimento.ID_ESTADO,
            }))
        );
        setOptionsCidade(() =>
            lstCidades?.map((empreendimento) => ({
                label: empreendimento.DS_CIDADE,
                value: empreendimento.ID_CIDADE,
            }))
        );
    }, [lstProfissoes, lstEstados, lstCidades]);
    const history = useHistory();
    const { execute: CadastrarCliente, loading: cadastrarClienteLoading } =
        useAsyncCallback(CadastrarClienteController);

    function handleCadastrarCliente(formData: ICadastrarCliente) {
        CadastrarCliente({
            ...formData,
            CONTA: {
                DS_NOME: formData.CONTA?.DS_NOME,
                ID_TIPO_CONTA: Number(formData.CONTA.ID_TIPO_CONTA)
                    ? Number(formData.CONTA.ID_TIPO_CONTA)
                    : undefined,
                DS_SITE_WEB: formData.CONTA?.DS_SITE_WEB,
                DT_ALTERACAO_RECEBER_COBRANCA: moment().format(
                    "YYYY-MM-DD HH:mm:ss"
                ),
                ID_CHAVE_ERP: formData.CONTA?.ID_CHAVE_ERP,
                ID_CONTA_PAI: 0,
                ID_MOTIVO_COMPRA: Number(formData.CONTA?.ID_MOTIVO_COMPRA)
                    ? Number(formData.CONTA?.ID_MOTIVO_COMPRA)
                    : undefined,
                ID_PERFIL_TIPO_CONTA: Number(
                    formData.CONTA?.ID_PERFIL_TIPO_CONTA
                )
                    ? Number(formData.CONTA?.ID_PERFIL_TIPO_CONTA)
                    : undefined,
                ID_SETOR: Number(formData.CONTA?.ID_SETOR)
                    ? Number(formData.CONTA?.ID_SETOR)
                    : undefined,
                ID_USUARIO_ALTERACAO_RECEBER_COBRANCA: UserInfor.ID_USUARIO,
                ID_USUARIO_PROPRIETARIO: Number(
                    formData.CONTA?.ID_USUARIO_PROPRIETARIO
                )
                    ? Number(formData.CONTA?.ID_USUARIO_PROPRIETARIO)
                    : undefined,
                ENDERECO: {
                    DS_BAIRRO: formData.CONTA.ENDERECO?.DS_BAIRRO,
                    DS_COMPLEMENTO: formData.CONTA.ENDERECO?.DS_COMPLEMENTO,
                    DS_LOGRADOURO: formData.CONTA.ENDERECO?.DS_LOGRADOURO,
                    FL_INTERNACIONAL_COBRANCA:
                        formData.CONTA.ENDERECO?.FL_INTERNACIONAL_COBRANCA,
                    ID_CIDADE: Number(idCidade),
                    NR_CEP: formData.CONTA.ENDERECO?.NR_CEP,
                    NR_ENDERECO: Number(formData.CONTA.ENDERECO?.NR_ENDERECO)
                        ? Number(formData.CONTA.ENDERECO?.NR_ENDERECO)
                        : undefined,
                },
                DADOS_BANCARIOS_CONTA: {
                    ID_BANCO: Number(
                        formData.CONTA.DADOS_BANCARIOS_CONTA?.ID_BANCO
                    )
                        ? Number(formData.CONTA.DADOS_BANCARIOS_CONTA?.ID_BANCO)
                        : undefined,
                    NR_AGENCIA_BANCO: Number(
                        formData.CONTA.DADOS_BANCARIOS_CONTA?.NR_AGENCIA_BANCO
                    )
                        ? Number(
                              formData.CONTA.DADOS_BANCARIOS_CONTA
                                  ?.NR_AGENCIA_BANCO
                          )
                        : undefined,
                    NR_CONTA_BANCO: Number(
                        formData.CONTA.DADOS_BANCARIOS_CONTA?.NR_CONTA_BANCO
                    )
                        ? Number(
                              formData.CONTA.DADOS_BANCARIOS_CONTA
                                  ?.NR_CONTA_BANCO
                          )
                        : undefined,
                },
                DOCS_CADASTRO_CONTA: {
                    NR_CPF: formData.CONTA.DOCS_CADASTRO_CONTA?.NR_CPF?.replace(
                        /[.-]/g,
                        ""
                    ),
                    DS_RG_CATEGORIA:
                        formData.CONTA.DOCS_CADASTRO_CONTA?.DS_RG_CATEGORIA,
                    DS_RG_ORGAO_EMISSOR:
                        formData.CONTA.DOCS_CADASTRO_CONTA?.DS_RG_ORGAO_EMISSOR,
                    DS_RG_TIPO: formData.CONTA.DOCS_CADASTRO_CONTA?.DS_RG_TIPO,
                    DS_RG_UF_EMISSOR:
                        formData.CONTA.DOCS_CADASTRO_CONTA?.DS_RG_UF_EMISSOR,
                    DT_RG_EMISSAO:
                        formData.CONTA.DOCS_CADASTRO_CONTA?.DT_RG_EMISSAO,
                    DT_RG_VALIDADE:
                        formData.CONTA.DOCS_CADASTRO_CONTA?.DT_RG_VALIDADE,
                    NR_REGISTRO_JUNTA: Number(
                        formData.CONTA.DOCS_CADASTRO_CONTA?.NR_REGISTRO_JUNTA
                    )
                        ? Number(
                              formData.CONTA.DOCS_CADASTRO_CONTA
                                  ?.NR_REGISTRO_JUNTA
                          )
                        : undefined,
                    NR_RG: formData.CONTA.DOCS_CADASTRO_CONTA?.NR_RG,
                },
                INFO_CADASTRO_CONTA: {
                    DS_LOGIN_PORTAL:
                        formData.CONTA.INFO_CADASTRO_CONTA?.DS_LOGIN_PORTAL,
                    DS_OBSERVACAO:
                        formData.CONTA.INFO_CADASTRO_CONTA?.DS_OBSERVACAO,
                    DS_SENHA_PORTAL:
                        formData.CONTA.INFO_CADASTRO_CONTA?.DS_SENHA_PORTAL,
                    DT_ADMISSAO:
                        formData.CONTA.INFO_CADASTRO_CONTA?.DT_ADMISSAO,
                    DT_CADASTRO:
                        formData.CONTA.INFO_CADASTRO_CONTA?.DT_CADASTRO,
                    FL_ACEITE_TERMO:
                        formData.CONTA.INFO_CADASTRO_CONTA?.FL_ACEITE_TERMO,
                    FL_CLIENTE_PRIORITARIO:
                        formData.CONTA.INFO_CADASTRO_CONTA
                            ?.FL_CLIENTE_PRIORITARIO,
                    FL_LOGIN_PORTAL_VALIDADO:
                        formData.CONTA.INFO_CADASTRO_CONTA
                            ?.FL_LOGIN_PORTAL_VALIDADO,
                    FL_RECEBER_COBRANCA:
                        formData.CONTA.INFO_CADASTRO_CONTA?.FL_RECEBER_COBRANCA,
                    ID_CATEGORIA_ATENDIMENTO: Number(
                        formData.CONTA.INFO_CADASTRO_CONTA
                            ?.ID_CATEGORIA_ATENDIMENTO
                    )
                        ? Number(
                              formData.CONTA.INFO_CADASTRO_CONTA
                                  ?.ID_CATEGORIA_ATENDIMENTO
                          )
                        : undefined,
                    ID_TIPO_CANAL_ATENDIMENTO: Number(
                        formData.CONTA.INFO_CADASTRO_CONTA
                            ?.ID_TIPO_CANAL_ATENDIMENTO
                    )
                        ? Number(
                              formData.CONTA.INFO_CADASTRO_CONTA
                                  ?.ID_TIPO_CANAL_ATENDIMENTO
                          )
                        : undefined,
                    ID_USUARIO_CADASTRO: UserInfor.ID_USUARIO,
                },
                LEAD_CONTA: {
                    FL_CHAT_TO_LEAD: formData.CONTA.LEAD_CONTA?.FL_CHAT_TO_LEAD,
                    FL_WEB_TO_LEAD: formData.CONTA.LEAD_CONTA?.FL_WEB_TO_LEAD,
                    ID_ORIGEM_LEAD: Number(
                        formData.CONTA.LEAD_CONTA?.ID_ORIGEM_LEAD
                    )
                        ? Number(formData.CONTA.LEAD_CONTA?.ID_ORIGEM_LEAD)
                        : undefined,
                },
                OCUPACAO_CONTA: {
                    DS_BAIRRO_OCUPACAO:
                        formData.CONTA.OCUPACAO_CONTA?.DS_BAIRRO_OCUPACAO,
                    DS_EMPRESA_EMPREGADORA:
                        formData.CONTA.OCUPACAO_CONTA?.DS_EMPRESA_EMPREGADORA,
                },
                PERFIL_CLIENTE: {
                    DS_EMAIL: formData.CONTA.PERFIL_CLIENTE?.DS_EMAIL,
                    DS_ESCOLARIDADE:
                        formData.CONTA.PERFIL_CLIENTE?.DS_ESCOLARIDADE,
                    DS_ESTADO_CIVIL:
                        formData.CONTA.PERFIL_CLIENTE?.DS_ESTADO_CIVIL,
                    DS_FAIXA_ETARIA:
                        formData.CONTA.PERFIL_CLIENTE?.DS_FAIXA_ETARIA,
                    DS_MELHOR_HORARIO_ATENDIMENTO:
                        formData.CONTA.PERFIL_CLIENTE
                            ?.DS_MELHOR_HORARIO_ATENDIMENTO,
                    DS_NACIONALIDADE:
                        formData.CONTA.PERFIL_CLIENTE?.DS_NACIONALIDADE,
                    DS_NATURALIDADE:
                        formData.CONTA.PERFIL_CLIENTE?.DS_NATURALIDADE,
                    DS_NOME_MAE: formData.CONTA.PERFIL_CLIENTE?.DS_NOME_MAE,
                    DS_NOME_PAI: formData.CONTA.PERFIL_CLIENTE?.DS_NOME_PAI,
                    DS_PACTO_ANTE_NUPCIAL:
                        formData.CONTA.PERFIL_CLIENTE?.DS_PACTO_ANTE_NUPCIAL,
                    DS_PROFISSAO: String(idProfissao),
                    DS_REGIME_COMUNHAO:
                        formData.CONTA.PERFIL_CLIENTE?.DS_REGIME_COMUNHAO,
                    DS_SAUDACAO: formData.CONTA.PERFIL_CLIENTE?.DS_SAUDACAO,
                    DS_SEXO: formData.CONTA.PERFIL_CLIENTE?.DS_SEXO,
                    DS_TEMPO_RESIDENCIA:
                        formData.CONTA.PERFIL_CLIENTE?.DS_TEMPO_RESIDENCIA,
                    DS_TITULO: formData.CONTA.PERFIL_CLIENTE?.DS_TITULO,
                    DT_CASAMENTO: formData.CONTA.PERFIL_CLIENTE?.DT_CASAMENTO,
                    DT_FIM_ANTENUPCIAL:
                        formData.CONTA.PERFIL_CLIENTE?.DT_FIM_ANTENUPCIAL,
                    DT_INICIO_ANTENUPCIAL:
                        formData.CONTA.PERFIL_CLIENTE?.DT_INICIO_ANTENUPCIAL,
                    DT_NASCIMENTO: formData.CONTA.PERFIL_CLIENTE?.DT_NASCIMENTO,
                    FL_INTERNACIONAL:
                        formData.CONTA.PERFIL_CLIENTE?.FL_INTERNACIONAL,
                    FL_PACTO_ANTE_NUPCIAL:
                        formData.CONTA.PERFIL_CLIENTE?.FL_PACTO_ANTE_NUPCIAL,
                    FL_TERRENEIRO: formData.CONTA.PERFIL_CLIENTE?.FL_TERRENEIRO,
                    ID_PROFISSAO_CONTA: Number(
                        formData.CONTA.PERFIL_CLIENTE?.ID_PROFISSAO_CONTA
                    )
                        ? Number(
                              formData.CONTA.PERFIL_CLIENTE?.ID_PROFISSAO_CONTA
                          )
                        : undefined,
                    NR_DEPENDENTES: Number(
                        formData.CONTA.PERFIL_CLIENTE?.NR_DEPENDENTES
                    )
                        ? Number(formData.CONTA.PERFIL_CLIENTE?.NR_DEPENDENTES)
                        : undefined,
                    NR_FILHOS: Number(formData.CONTA.PERFIL_CLIENTE?.NR_FILHOS)
                        ? Number(formData.CONTA.PERFIL_CLIENTE?.NR_FILHOS)
                        : undefined,
                },
                PERFIL_FINANCEIRO: {
                    DS_IMOVEL_PROPRIO:
                        formData.CONTA.PERFIL_FINANCEIRO?.DS_IMOVEL_PROPRIO,
                    DS_RAZAO_SOCIAL:
                        formData.CONTA.PERFIL_FINANCEIRO?.DS_RAZAO_SOCIAL,
                    DS_TIPO_VEICULO:
                        formData.CONTA.PERFIL_FINANCEIRO?.DS_TIPO_VEICULO,
                    DS_VEICULO_PROPRIO:
                        formData.CONTA.PERFIL_FINANCEIRO?.DS_VEICULO_PROPRIO,
                    FL_FGTS: formData.CONTA.PERFIL_FINANCEIRO?.FL_FGTS,
                    ID_PERFIL_FINANCEIRO_CONTA: Number(
                        formData.CONTA.PERFIL_FINANCEIRO
                            ?.ID_PERFIL_FINANCEIRO_CONTA
                    )
                        ? Number(
                              formData.CONTA.PERFIL_FINANCEIRO
                                  ?.ID_PERFIL_FINANCEIRO_CONTA
                          )
                        : undefined,
                    NR_INSCRICAO_ESTADUAL:
                        formData.CONTA.PERFIL_FINANCEIRO?.NR_INSCRICAO_ESTADUAL,
                    NR_INSCRICAO_MUNICIPAL:
                        formData.CONTA.PERFIL_FINANCEIRO
                            ?.NR_INSCRICAO_MUNICIPAL,
                    NR_QUANTIDADE_FUNCIONARIO: Number(
                        formData.CONTA.PERFIL_FINANCEIRO
                            ?.NR_QUANTIDADE_FUNCIONARIO
                    )
                        ? Number(
                              formData.CONTA.PERFIL_FINANCEIRO
                                  ?.NR_QUANTIDADE_FUNCIONARIO
                          )
                        : undefined,
                    NR_SCORE: Number(formData.CONTA.PERFIL_FINANCEIRO?.NR_SCORE)
                        ? Number(formData.CONTA.PERFIL_FINANCEIRO?.NR_SCORE)
                        : undefined,
                    VL_FGTS: formData.CONTA.PERFIL_FINANCEIRO?.VL_FGTS,
                    VL_RECEITA_ANUAL:
                        formData.CONTA.PERFIL_FINANCEIRO?.VL_RECEITA_ANUAL,
                    VL_RENDA: formData.CONTA.PERFIL_FINANCEIRO?.VL_RENDA,
                },
            },
            CONTATO: {
                DS_EMAIL: formData.CONTATO?.DS_EMAIL,
                DS_NOME: formData.CONTATO?.DS_NOME,
                NR_CPF: formData.CONTATO?.NR_CPF?.replace(/[.-]/g, ""),
                DS_BAIRRO: formData.CONTATO?.DS_BAIRRO,
                DS_CONTA: formData.CONTATO?.DS_CONTA,
                DS_LOGRADOURO: formData.CONTATO?.DS_LOGRADOURO,
                DS_PROFISSAO: formData.CONTATO?.DS_PROFISSAO,
                ID_CIDADE: formData.CONTATO?.ID_CIDADE
                    ? formData.CONTATO?.ID_CIDADE
                    : undefined,
                NR_CEP: idNrCPF,
                NR_ENDERECO: Number(formData.CONTATO?.NR_ENDERECO)
                    ? Number(formData.CONTATO?.NR_ENDERECO)
                    : undefined,
                DS_CIDADE: formData.CONTATO?.DS_CIDADE,
                DS_ESTADO: formData.CONTATO?.DS_ESTADO,
            },
            ID_RELACAO_CLIENTE: Number(formData.ID_RELACAO_CLIENTE),
        }).then(() => {
            history.push(ACESSOS.GERAL.TELAS.GESTAO_CLIENTES.DS_PATH);
        });
    }

    return (
        <div className="row">
            <FormProvider {...formCadastrarCliente}>
                <form
                    onSubmit={handleSubmit(handleCadastrarCliente)}
                    typeof="button"
                    className="card card-custom w-100 h-100"
                >
                    <h1 className="text-center pt-6">Cadastrar Cliente</h1>
                    <hr />
                    <div className="p-6">
                        <Wizard
                            {...wizard}
                            stepInfo={{
                                Conta: {
                                    title: "Conta",
                                    valid: objContaIsValid,
                                },
                                Endereco: {
                                    title: "Endereço",
                                },
                                PerfilCliente: {
                                    title: "Perfil Cliente",
                                    valid: objContaPerfilClienteIsValid,
                                },
                                PerfilFinanceiro: {
                                    title: "Perfil Financeiro",
                                },
                                InformacaoCadastroConta: {
                                    title: "Informação Cadastro Conta",
                                },
                                DocumentosCadastroConta: {
                                    title: "Documentos de Cadastro Conta",
                                    valid: objContaDocsCadastroContaIsValid,
                                },
                                DadosBancariosCobranca: {
                                    title: "Dados Bancários Cobrança",
                                },
                                OcupacaoConta: {
                                    title: "Ocupação Conta",
                                },
                                LeadConta: {
                                    title: "Lead Conta",
                                },
                                Contato: {
                                    title: "Contato",
                                    valid: objContatoIsValid,
                                },
                                CadastrarCliente: {
                                    title: "Finalizar Cadastro",
                                },
                            }}
                        >
                            <WizardStep stepKey="Conta">
                                <h3 className="text-center py-3">Conta</h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Nome</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.DS_NOME && "is-invalid"
                                            }`}
                                            name="CONTA.DS_NOME"
                                            ref={register({
                                                required: true,
                                            })}
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.ID_TIPO_CONTA &&
                                                "is-invalid"
                                            }`}
                                            controller={
                                                ListarTipoContasController
                                            }
                                            getDS={(ds) => ds.DS_TIPO_CONTA}
                                            getKeyValue={(key) =>
                                                key.ID_TIPO_CONTA
                                            }
                                            ref={register({
                                                required: true,
                                            })}
                                            label="Tipo de Conta"
                                            name="CONTA.ID_TIPO_CONTA"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.ID_SETOR && "is-invalid"
                                            }`}
                                            controller={ListarSetorController}
                                            getDS={(ds) => ds.DS_SETOR}
                                            getKeyValue={(key) => key.ID_SETOR}
                                            label="Setor"
                                            name="CONTA.ID_SETOR"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Site Web</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DS_SITE_WEB"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Chave ERP</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ID_CHAVE_ERP"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarPerfilTipoContaController
                                            }
                                            getDS={(ds) =>
                                                ds.DS_PERFIL_TIPO_CONTA
                                            }
                                            getKeyValue={(key) =>
                                                key.ID_PERFIL_TIPO_CONTA
                                            }
                                            label="Perfil Tipo Conta"
                                            name="CONTA.ID_PERFIL_TIPO_CONTA"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarUsuariosController
                                            }
                                            getDS={(ds) => ds.DS_NOME}
                                            getKeyValue={(key) =>
                                                key.ID_USUARIO
                                            }
                                            label="Usuário Proprietário"
                                            name="CONTA.ID_USUARIO_PROPRIETARIO"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Dt. de Alteração Receber Cobrança
                                        </label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.DT_ALTERACAO_RECEBER_COBRANCA"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarMotivoCompraController
                                            }
                                            getDS={(ds) => ds.DS_MOTIVO_COMPRA}
                                            getKeyValue={(key) =>
                                                key.ID_MOTIVO_COMPRA
                                            }
                                            label="Motivo Compra"
                                            name="CONTA.ID_MOTIVO_COMPRA"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="Endereco">
                                <h3 className="text-center py-3">Endereço</h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número de Endereço</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.ENDERECO.NR_ENDERECO"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Complemento de Cobrança</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ENDERECO.DS_COMPLEMENTO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Cobrança Internacional</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.ENDERECO.FL_INTERNACIONAL_COBRANCA"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>CEP</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ENDERECO.NR_CEP"
                                            maxLength={10}
                                            onChange={FormatadorParaCEP}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Estado</label>

                                        <Select
                                            className={`placeholder-dark-50`}
                                            name="CONTA.ENDERECO.ID_ESTADO"
                                            options={optionsEstado}
                                            onChange={(e) => {
                                                setIdEstado(e?.value);
                                            }}
                                            noOptionsMessage={() =>
                                                "Nenhuma opção"
                                            }
                                            placeholder={""}
                                            menuPlacement="auto"
                                            styles={customStyles}
                                            isClearable
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Cidade</label>
                                        <Select
                                            name="CONTA.ENDERECO.DS_CIDADE"
                                            options={optionsCidade}
                                            onChange={(e) => {
                                                setIdCidade(e?.value as number);
                                            }}
                                            noOptionsMessage={() =>
                                                "Nenhuma opção"
                                            }
                                            placeholder={""}
                                            menuPlacement="auto"
                                            styles={customStyles}
                                            isClearable
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Bairro</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ENDERECO.DS_BAIRRO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Logradouro</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ENDERECO.DS_LOGRADOURO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Numéro do Endereço</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.ENDERECO.NR_ENDERECO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Complemento</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.ENDERECO.DS_COMPLEMENTO"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="PerfilCliente">
                                <h3 className="text-center py-3">
                                    Perfil Cliente
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Nome do Pai</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_NOME_PAI"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Nome do Mãe</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_NOME_MAE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Saudação</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_SAUDACAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Profissão</label>
                                        <Select
                                            options={optionsProfissoes}
                                            noOptionsMessage={() =>
                                                "Nenhuma opção"
                                            }
                                            styles={customStyles}
                                            menuPlacement="auto"
                                            onChange={(e) => {
                                                setIdProfissao(
                                                    e?.label as string
                                                );
                                            }}
                                            placeholder={""}
                                            isClearable
                                            isSearchable
                                            name="CONTA.PERFIL_CLIENTE.DS_PROFISSAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Nascimento</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.PERFIL_CLIENTE.DT_NASCIMENTO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Faixa Etária</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_FAIXA_ETARIA"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarProfissoesController
                                            }
                                            getDS={(ds) => ds.DS_PROFISSAO}
                                            getKeyValue={(key) =>
                                                key.ID_PROFISSAO
                                            }
                                            label="Profissão Conta"
                                            name="CONTA.PERFIL_CLIENTE.ID_PROFISSAO_CONTA"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Sexo</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_SEXO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número de Filhos</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.PERFIL_CLIENTE.NR_FILHOS"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número de Dependentes</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.PERFIL_CLIENTE.NR_DEPENDENTES"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Nacionalidade</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_NACIONALIDADE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Email</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.PERFIL_CLIENTE
                                                    ?.DS_EMAIL && "is-invalid"
                                            }`}
                                            type="email"
                                            name="CONTA.PERFIL_CLIENTE.DS_EMAIL"
                                            ref={register({
                                                required: true,
                                            })}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Título</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_TITULO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Melhor Horário de Atendimento
                                        </label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="time"
                                            name="CONTA.PERFIL_CLIENTE.DS_MELHOR_HORARIO_ATENDIMENTO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Naturalidade</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_NATURALIDADE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Regime de Comunhão</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_REGIME_COMUNHAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Estado Civil</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_ESTADO_CIVIL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Casamento</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.PERFIL_CLIENTE.DT_CASAMENTO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Pacto Antenupcial</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.PERFIL_CLIENTE.FL_PACTO_ANTE_NUPCIAL"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Pacto Antenupcial</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_PACTO_ANTE_NUPCIAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. Início Antenupcial</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.PERFIL_CLIENTE.DT_INICIO_ANTENUPCIAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. Fim Antenupcial</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.PERFIL_CLIENTE.DT_FIM_ANTENUPCIAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Escolaridade</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_ESCOLARIDADE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Terreneiro</label>
                                        <div className="d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.PERFIL_CLIENTE.FL_TERRENEIRO"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Internacional</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.PERFIL_CLIENTE.FL_INTERNACIONAL"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Tempo de Residência</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_CLIENTE.DS_TEMPO_RESIDENCIA"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="PerfilFinanceiro">
                                <h3 className="text-center py-3">
                                    Perfil Financeiro
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarPerfilFinanceiroController
                                            }
                                            getDS={(ds) =>
                                                ds.DS_PERFIL_FINANCEIRO_CONTA
                                            }
                                            getKeyValue={(key) =>
                                                key.ID_PERFIL_FINANCEIRO_CONTA
                                            }
                                            label="Conta Perfil Financeiro"
                                            name="CONTA.PERFIL_FINANCEIRO.ID_PERFIL_FINANCEIRO_CONTA"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número Score</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.PERFIL_FINANCEIRO.NR_SCORE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Imóvel Próprio</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.DS_IMOVEL_PROPRIO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Veículo Próprio</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.DS_VEICULO_PROPRIO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Tipo de Veículo</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.DS_TIPO_VEICULO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Valor da Renda</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.PERFIL_FINANCEIRO
                                                    ?.VL_RENDA && "is-invalid"
                                            }`}
                                            name="CONTA.PERFIL_FINANCEIRO.VL_RENDA"
                                            ref={register({
                                                setValueAs: (v: string) => {
                                                    return Number(
                                                        MoneyReaisFieldMask.unMask(
                                                            v
                                                        )
                                                    );
                                                },
                                            })}
                                            onChange={geradorMascaraFinanceiraPerfiLFinanceiro(
                                                "VL_RENDA"
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>FGTS</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.PERFIL_FINANCEIRO.FL_FGTS"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Valor FGTS</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.VL_FGTS"
                                            ref={register({
                                                setValueAs: (v: string) => {
                                                    return Number(
                                                        MoneyReaisFieldMask.unMask(
                                                            v
                                                        )
                                                    );
                                                },
                                            })}
                                            onChange={geradorMascaraFinanceiraPerfiLFinanceiro(
                                                "VL_FGTS"
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Razão Social</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.DS_RAZAO_SOCIAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Quantidade de Funcionários
                                        </label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.PERFIL_FINANCEIRO.NR_QUANTIDADE_FUNCIONARIO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Inscrição Municipal</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.NR_INSCRICAO_MUNICIPAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Número de Inscrição Estadual
                                        </label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.PERFIL_FINANCEIRO.NR_INSCRICAO_ESTADUAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Valor Receita Anual</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.PERFIL_FINANCEIRO
                                                    ?.VL_RECEITA_ANUAL &&
                                                "is-invalid"
                                            }`}
                                            name="CONTA.PERFIL_FINANCEIRO.VL_RECEITA_ANUAL"
                                            ref={register({
                                                setValueAs: (v: string) => {
                                                    return Number(
                                                        MoneyReaisFieldMask.unMask(
                                                            v
                                                        )
                                                    );
                                                },
                                            })}
                                            onChange={geradorMascaraFinanceiraPerfiLFinanceiro(
                                                "VL_RECEITA_ANUAL"
                                            )}
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="InformacaoCadastroConta">
                                <h3 className="text-center py-3">
                                    Informação Cadastro Conta
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Observação</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.INFO_CADASTRO_CONTA.DS_OBSERVACAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Login Portal</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.INFO_CADASTRO_CONTA.DS_LOGIN_PORTAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Senha Portal</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.INFO_CADASTRO_CONTA.DS_SENHA_PORTAL"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Login Portal Validade</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.INFO_CADASTRO_CONTA.FL_LOGIN_PORTAL_VALIDADO"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>À Receber Cobrança</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.INFO_CADASTRO_CONTA.FL_RECEBER_COBRANCA"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Canal de Atendimento</label>
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={listarCanalAtendimento}
                                            getDS={(ds) =>
                                                ds.DS_TIPO_CANAL_ATENDIMENTO
                                            }
                                            getKeyValue={(key) =>
                                                key.ID_TIPO_CANAL_ATENDIMENTO
                                            }
                                            name="CONTA.INFO_CADASTRO_CONTA.ID_TIPO_CANAL_ATENDIMENTO"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={
                                                ListarCategoriasAtendimentosPaiController
                                            }
                                            getDS={(ds) =>
                                                ds.DS_CATEGORIA_ATENDIMENTO
                                            }
                                            getKeyValue={(key) =>
                                                key.ID_CATEGORIA_ATENDIMENTO
                                            }
                                            label="Categoria de Atendimento"
                                            name="CONTA.INFO_CADASTRO_CONTA.ID_CATEGORIA_ATENDIMENTO"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Cliente Proprietário</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.INFO_CADASTRO_CONTA.FL_CLIENTE_PRIORITARIO"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Aceite os Termos</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.INFO_CADASTRO_CONTA.FL_ACEITE_TERMO"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Cadastro</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.INFO_CADASTRO_CONTA.DT_CADASTRO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Admissão</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.INFO_CADASTRO_CONTA.DT_ADMISSAO"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="DocumentosCadastroConta">
                                <h3 className="text-center py-3">
                                    Documentos de Cadastro Conta
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>CPF/CNPJ</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTA
                                                    ?.DOCS_CADASTRO_CONTA
                                                    ?.NR_CPF && "is-invalid"
                                            }`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.NR_CPF"
                                            ref={register({
                                                required: true,
                                                validate: (value: string) =>
                                                    /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(
                                                        value
                                                    ) ||
                                                    /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/.test(
                                                        value
                                                    ) ||
                                                    "Formato inválido",
                                            })}
                                            maxLength={18}
                                            onChange={formatterCPF_CNPJ}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.NR_RG"
                                            onChange={FormatadorParaRG}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Orgão Emissor RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.DS_RG_ORGAO_EMISSOR"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>UF Emissor RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.DS_RG_UF_EMISSOR"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Emissão do RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.DOCS_CADASTRO_CONTA.DT_RG_EMISSAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Tipo RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.DS_RG_TIPO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Categoria RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.DOCS_CADASTRO_CONTA.DS_RG_CATEGORIA"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Dt. de Validade do RG</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="date"
                                            name="CONTA.DOCS_CADASTRO_CONTA.DT_RG_VALIDADE"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Número da Junta de Registro
                                        </label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.DOCS_CADASTRO_CONTA.NR_REGISTRO_JUNTA"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="DadosBancariosCobranca">
                                <h3 className="text-center py-3">
                                    Dados Bancários Cobrança
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={ListarBancosController}
                                            getDS={(ds) => ds.DS_BANCO}
                                            getKeyValue={(key) => key.ID_BANCO}
                                            label="Banco"
                                            name="CONTA.DADOS_BANCARIOS_CONTA.ID_BANCO"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número da Agência Banco</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.DADOS_BANCARIOS_CONTA.NR_AGENCIA_BANCO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número da Conta do Banco</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="number"
                                            name="CONTA.DADOS_BANCARIOS_CONTA.NR_CONTA_BANCO"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="OcupacaoConta">
                                <h3 className="text-center py-3">
                                    Ocupação Conta
                                </h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Bairro de Ocupação</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.OCUPACAO_CONTA.DS_BAIRRO_OCUPACAO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Empresa Empregadora</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTA.OCUPACAO_CONTA.DS_EMPRESA_EMPREGADORA"
                                        />
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="LeadConta">
                                <h3 className="text-center py-3">Lead Conta</h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <LazySelect
                                            className={`form-control placeholder-dark-50`}
                                            controller={GetOrigemLeadController}
                                            getDS={(ds) => ds.DS_ORIGEM_LEAD}
                                            getKeyValue={(key) =>
                                                key.ID_ORIGEM_LEAD
                                            }
                                            label="Origem Lead"
                                            name="CONTA.LEAD_CONTA.ID_ORIGEM_LEAD"
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Web para Lead</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.LEAD_CONTA.FL_WEB_TO_LEAD"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>Chat para Lead</label>
                                        <div className=" d-flex justify-content-start">
                                            <Switch
                                                type="checkbox"
                                                color="success"
                                                name="CONTA.LEAD_CONTA.FL_CHAT_TO_LEAD"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </WizardStep>
                            <WizardStep stepKey="Contato">
                                <h3 className="text-center py-3">Contato</h3>

                                <div className="row">
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Nome</label>
                                        <input
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTATO
                                                    ?.DS_NOME && "is-invalid"
                                            }`}
                                            type="text"
                                            name="CONTATO.DS_NOME"
                                            ref={register({
                                                required: true,
                                            })}
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Email</label>
                                        <input
                                            className={`form-control placeholder-dark-50 ${
                                                formState.errors.CONTATO
                                                    ?.DS_EMAIL && "is-invalid"
                                            }`}
                                            type="email"
                                            name="CONTATO.DS_EMAIL"
                                            ref={register({ required: true })}
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>CPF</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTATO.NR_CPF"
                                            maxLength={14}
                                            onChange={formatterCPF_CNPJ}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>CEP</label>
                                        <div className="input-icon input-icon-right">
                                            <input
                                                name="NR_CEP"
                                                className="form-control"
                                                ref={register()}
                                                value={idNrCPF}
                                                onChange={(e) => {
                                                    setIdNrCPF(e.target.value);
                                                }}
                                            />
                                            <span
                                                onClick={async () => {
                                                    const cep =
                                                        `${getValues(
                                                            "NR_CEP"
                                                        )}`?.replace(
                                                            /([^\d])+/gim,
                                                            ""
                                                        ) || "0";
                                                    if (cep?.length === 8) {
                                                        await BuscaCEP(
                                                            Number(cep)
                                                        )
                                                            .then(
                                                                (InformCep) => {
                                                                    GetCidadeController(
                                                                        InformCep.localidade
                                                                    ).then(
                                                                        (
                                                                            cidade
                                                                        ) => {
                                                                            setCidade(
                                                                                cidade
                                                                            );
                                                                            setEstadoID(
                                                                                cidade.ID_ESTADO
                                                                            );
                                                                        }
                                                                    );
                                                                    setValue(
                                                                        `DS_BAIRRO`,
                                                                        InformCep.bairro
                                                                    );
                                                                    setValue(
                                                                        `DS_LOGRADOURO`,
                                                                        InformCep.logradouro
                                                                    );
                                                                }
                                                            )
                                                            .catch(
                                                                ValidationErr
                                                            );
                                                    }
                                                }}
                                            >
                                                <i className="flaticon2-search-1 icon-md"></i>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Estado</label>
                                        <LazySelect
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTATO
                                                    ?.DS_ESTADO && "is-invalid"
                                            }`}
                                            name="CONTATO.ID_ESTADO"
                                            controller={ListarEstadosController}
                                            getDS={(e) => e.DS_ESTADO}
                                            getKeyValue={(e) => e.ID_ESTADO}
                                            disabled
                                            value={estadoID}
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Cidade</label>
                                        <select
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors.CONTATO
                                                    ?.ID_CIDADE && "is-invalid"
                                            }`}
                                            name="ID_CIDADE"
                                            disabled
                                            value={cidade?.ID_CIDADE}
                                        >
                                            <option value={cidade?.ID_CIDADE}>
                                                {cidade?.DS_CIDADE}
                                            </option>
                                        </select>
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Bairro</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTATO.DS_BAIRRO"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Endereço</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTATO.DS_LOGRADOURO"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Número</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            name="CONTATO.NR_ENDERECO"
                                        />
                                    </div>
                                    <div className="col-12 col-md-2 py-3">
                                        <label>Complemento</label>
                                        <input
                                            className={`form-control placeholder-dark-50`}
                                            type="text"
                                            name="CONTATO.DS_COMPLEMENTO_ENDERECO"
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 py-3">
                                        <label>
                                            Tipo de Relação com Cliente
                                        </label>
                                        <LazySelect
                                            className={`form-control placeholder-dark-50  ${
                                                formState.errors
                                                    .ID_RELACAO_CLIENTE &&
                                                "is-invalid"
                                            }`}
                                            controller={
                                                ListarTipoRelacaoClienteController
                                            }
                                            getDS={(trc) =>
                                                trc.DS_TIPO_RELACAO_CLIENTE
                                            }
                                            getKeyValue={(trc) =>
                                                trc.TIPO_RELACAO_CLIENTE
                                            }
                                            name="ID_RELACAO_CLIENTE"
                                            ref={register({
                                                required: true,
                                            })}
                                        >
                                            <option></option>
                                        </LazySelect>
                                    </div>
                                </div>
                            </WizardStep>{" "}
                            <WizardStep stepKey="CadastrarCliente">
                                <h3 className="text-center py-3">
                                    Finalizar Cadastro
                                </h3>
                            </WizardStep>
                            <WizardControl onClick={trigger}>
                                <WizardControlStep step="CadastrarCliente">
                                    <WizardControlStepButton />
                                    <WizardControlStepButton
                                        disabled={
                                            cadastrarClienteLoading ||
                                            !(
                                                objContaIsValid &&
                                                objContaPerfilClienteIsValid &&
                                                objContaDocsCadastroContaIsValid &&
                                                objContatoIsValid
                                            )
                                        }
                                        icon={faPlus}
                                        buttonType="submit"
                                        loading={cadastrarClienteLoading}
                                    >
                                        Cadastrar Cliente
                                    </WizardControlStepButton>
                                </WizardControlStep>
                            </WizardControl>
                        </Wizard>
                    </div>
                </form>
            </FormProvider>
        </div>
    );
}
